import { SKINCARE_PATH } from 'lib/constants/routes';
import { useRouter } from 'next/router';

export const isSkincarePath = (path: string) => path.startsWith(SKINCARE_PATH);

export const useIsSkincare = () => {
  const router = useRouter();

  /* NOTE: router.asPath will preserve the original route if it
   * has been redirected or rewritten. */
  return isSkincarePath(router.asPath);
};
